import { Component } from "react";
import "./AppDialog.css";
import PropTypes from "prop-types";
import Dialog from "./components/Dialog/Dialog";
import TalaeraSpinner from "./../TalaeraSpinner/TalaeraSpinner";
import { getErrorComponents } from "../../services/util";

/**
 * A default Talaera dialog component. It can have `<form>` inside, it should have `mode` equal to
 * `"form"` then.
 */
export default class AppDialog extends Component {
  render() {
    const mode = this.props.mode || "form";
    let childComponent;
    if (mode === "form") {
      childComponent = <AppDialogForm {...this.props} />;
    } else {
      childComponent = <div className="inner-container">{this.props.children}</div>;
    }

    return (
      <Dialog
        showDialog={this.props.showDialog || false}
        onClose={this.props.onClose}
        closeOnOuterClick={this.props.closeOnOuterClick}
        dataCy={this.props.dataCy}
        className={"app-dialog " + this.props.className}
      >
        {this.props.topBorder && <div className="top-border" />}
        <div className="dialog-content">
          <div className="inner">
            {this.props.showSpinner && (
              <div className="spinner-container">
                <TalaeraSpinner />
              </div>
            )}
            {childComponent}
          </div>
        </div>
      </Dialog>
    );
  }
}

class AppDialogForm extends Component {
  render() {
    const isValid = this.props.isValidForm;
    let formClassName = this.props.formClassName;
    if (!isValid) {
      formClassName += " invalid";
    }

    return (
      <>
        {this.props.titleComponent}
        <div
          className={
            this.props.showSpinner ? "form-container spinner-form" : "form-container"
          }
        >
          <form className={formClassName} onSubmit={this.props.onFormSubmit}>
            <div className="form-fields">{this.props.children}</div>
            {this.props.errors && getErrorComponents(this.props.errors)}
            {this.props.formActions}
          </form>
        </div>
      </>
    );
  }
}

AppDialog.propTypes = {
  /** Boolean value that defines whether to show dialog or not. */
  showDialog: PropTypes.bool.isRequired,
  /** Boolean value that defines whether to close the dialog if someone clicks outside of the modal window. */
  closeOnOuterClick: PropTypes.bool,
  /** A custom CSS class name that can be added to the dialog's default list of classes. */
  className: PropTypes.string,
  /** Function/callback that invokes when dialog is being closed. */
  onClose: PropTypes.func.isRequired,
  /** Dialog can have different modes: `"view"` or `"form"`. */
  mode: PropTypes.string,
  /** Action made on form submit */
  onFormSubmit: PropTypes.func,
  /** Boolean value that defines whether to show top border or not. */
  topBorder: PropTypes.bool,
  /** "Identificator" to use in cypress tests. */
  dataCy: PropTypes.string,
  /** Title component: JSX with a valid React component. */
  titleComponent: PropTypes.object,
  /** Boolean value that defines whether to show common for all dialogs spinner or not. */
  showSpinner: PropTypes.bool,
  /** Boolean value that defines whether the form is valid or not. */
  isValidForm: PropTypes.bool,
  /** Custom CSS class name that will be applied to dialog's form. */
  formClassName: PropTypes.string,
  /** Errors received during form validation or from the server. */
  errors: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  /** Form actions (JSX). */
  formActions: PropTypes.object,
};

AppDialogForm.propTypes = {
  /** Boolean value that defines whether to show common for all dialogs spinner or not. */
  showSpinner: PropTypes.bool,
  /** Boolean value that defines whether the form is valid or not. */
  isValidForm: PropTypes.bool,
  /** Custom CSS class name that will be applied to dialog's form. */
  formClassName: PropTypes.string,
  /** Errors received during form validation or from the server. */
  errors: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  /** Action made on form submit */
  onFormSubmit: PropTypes.func,
  /** Form actions (JSX). */
  formActions: PropTypes.object,
};
